<script>
	import { getTealiumID, registerPageComplete } from "../../tealium";
	import model from "../../stores/modelStore";
	import { projectSettings, referralTypes, yesNoOptions } from "../../config";
	import { calculateAge } from "../../helpers/dateHelpers";
	import contactRelationshipToClaimant from "../../config/relationshipToClaimant";
	import { isValid } from "../../validation";

	import Contact from "../../components/Contact.svelte";
	import Form from "../../components/Form.svelte";
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import Select from "../../components/Select.svelte";
	import PageSection from "../../components/PageSection.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";

	export let pageName = null;
	export let disabled = null;
	export let pageTitle = null;
	export let persistUrl = null;
	export let lastVisitedPage = null;

	let required = true;
	let buttons = null;

	if (!disabled) {
		$model.lastPageVisited = lastVisitedPage;
		document.title = pageTitle;

		$model.TealiumId = getTealiumID();
	}

	const handleSubmit = async (e) => {
		buttons.blockNext();

		let errors = isValid();

		if (!errors.length) {
			let response = await model.saveModelAsync(persistUrl);

			if (!response.success) {
				console.log(response);
			} else {
				registerPageComplete(pageName, $model.contact.emailAddress, $model.contact.phoneNumber);

				buttons.next();
			}
		} else {
			errors[0].scrollIntoView({ behavior: "smooth" });
		}

		buttons.unblock();
	};

	const handleDob = (e) => {
		if (
			e.detail.date &&
			calculateAge(e.detail.date, new Date()) < 18 &&
			calculateAge(e.detail.date, new Date()) >= 12
		) {
			$model.underAge = true;
		} else {
			$model.underAge = false;
		}
	};
</script>

<PageSection>
	<Form {disabled} id="form-personal-details" on:submit={handleSubmit}>
		<FormRow class="justify-content-center confirmation-hide">
			<FormColumn>
				<h4 class="text-center">{@html projectSettings.classActionName} Shift Class Actions</h4>
				<h1 class="text-center">Please provide your details</h1>
			</FormColumn>
		</FormRow>

		<hr class="primary" />

		<FormRow class="confirmation-box-shadow">
			<Contact
				bind:firstName={$model.contact.firstName}
				bind:surname={$model.contact.surname}
				bind:emailAddress={$model.contact.emailAddress}
				bind:phoneNumber={$model.contact.phoneNumber}
				bind:dateOfBirth={$model.contact.dateOfBirth}
				bind:address={$model.contact.address}
				idPrefix="contact"
				validator="dobEligibility"
				{required}
				{disabled}
				on:dateChange={handleDob}
				on:dateSelected={handleDob} />
		</FormRow>

		{#if $model.underAge}
			<div style="margin-top: 2em;">
				<h2>Legal Guardian</h2>
				<FormRow class="confirmation-box-shadow">
					<FormColumn>
						<Select
							{required}
							{disabled}
							label="Relationship to you"
							id="relationshipToClaimant"
							bind:value={$model.relationshipToClaimant}
							optionList={contactRelationshipToClaimant.options}
							textProperty="name"
							valueProperty="value" />
					</FormColumn>
				</FormRow>
				<div class="confirmation-box-shadow">
					<Contact
						bind:firstName={$model.secondaryContact.firstName}
						bind:surname={$model.secondaryContact.surname}
						bind:emailAddress={$model.secondaryContact.emailAddress}
						bind:phoneNumber={$model.secondaryContact.phoneNumber}
						bind:dateOfBirth={$model.secondaryContact.dateOfBirth}
						bind:address={$model.secondaryContact.address}
						idPrefix="secondary"
						{required}
						{disabled} />
				</div>
			</div>
		{/if}

		<FormRow class="confirmation-box-shadow">
			<FormColumn>
				<Select
					{required}
					{disabled}
					label="Where did you hear about our firm?"
					id="whereDidYouHear"
					bind:value={$model.whereDidYouHear}
					optionList={referralTypes}
					textProperty="name"
					valueProperty="name" />
			</FormColumn>
		</FormRow>

		<FormRow class="confirmation-hide">
			<FormColumn class="last">
				<NavigationButtons bind:buttons nextPageLabel={$model.confirmationPage ? "Next" : "Next"} />
			</FormColumn>
		</FormRow>
	</Form>
</PageSection>
